import {
  ServiceActivityStatus,
  ServiceActivityStatusTranslationMap,
} from '@wilson/interfaces';
import { FilterOptions } from '../../options.interface';

export const ServiceActivityFilterOptions: FilterOptions[] = [
  {
    id: ServiceActivityStatus.StaffAssigned,
    name: ServiceActivityStatusTranslationMap[
      ServiceActivityStatus.StaffAssigned
    ],
  },
  {
    id: ServiceActivityStatus.AssignedToShift,
    name: ServiceActivityStatusTranslationMap[
      ServiceActivityStatus.AssignedToShift
    ],
  },
  {
    id: ServiceActivityStatus.NotStaffed,
    name: ServiceActivityStatusTranslationMap[ServiceActivityStatus.NotStaffed],
  },
];
